import { ManagedEntry } from './platform/ManagedEntry';
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./app/App";
import { AppProviders } from "./app/providers";
import { removePublicPrerender } from "./marketing/publicPrerender";
import "./styles/tokens.css";
import "./styles/global.css";

const root = document.getElementById("root");
if (!root) throw new Error("React root element was not found");
removePublicPrerender(root);

createRoot(root).render(
  <StrictMode>
    <ManagedEntry><AppProviders>
      <App />
    </AppProviders></ManagedEntry>
  </StrictMode>,
);
